<div class="overlays-status" *ngIf="showStatus" [@timeline-status]>
	<div class="text-container">
		<span>{{overlaysStatusMessage$ | async}}</span>
		<button class="close">X</button>
	</div>
</div>
